<div class="poll-block show">
    <div class="field-title">
        {{ schema.title }}
    </div>
    <div *ngIf="schema.description" class="field-description">
        {{ schema.description }}
    </div>
    <input [name]="name" type="date" [attr.required]="schema.required || null" [formControl]="control">
</div>